import { render, staticRenderFns } from "./YourSpaceTrophies.vue?vue&type=template&id=78b6a58f&scoped=true"
import script from "./YourSpaceTrophies.vue?vue&type=script&lang=js"
export * from "./YourSpaceTrophies.vue?vue&type=script&lang=js"
import style0 from "./YourSpaceTrophies.vue?vue&type=style&index=0&id=78b6a58f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78b6a58f",
  null
  
)

export default component.exports